'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pager = (0, _react.memo)(function (_ref) {
  var offset = _ref.offset,
      itemsPerPage = _ref.itemsPerPage,
      totalItems = _ref.totalItems,
      currentPage = _ref.currentPage,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      maxPages = _ref.maxPages,
      disableCurrent = _ref.disableCurrent;

  if (!totalItems) return null;

  var lastPage = Math.ceil(totalItems / itemsPerPage) - 1;
  if (maxPages && maxPages > -1 && lastPage > maxPages - 1) lastPage = maxPages - 1;

  var startingPage = 0;
  var endingPage = lastPage;
  var freeOffset = void 0;

  if (currentPage - offset < 0) {
    startingPage = 0;
    freeOffset = offset - currentPage;
    endingPage = Math.min(lastPage, currentPage + offset + freeOffset);
  } else if (currentPage + offset > lastPage) {
    endingPage = lastPage;
    freeOffset = currentPage - lastPage + offset;
    startingPage = Math.max(0, currentPage - offset - freeOffset);
  } else {
    startingPage = currentPage - offset;
    endingPage = currentPage + offset;
  }

  var listPages = Array(endingPage - startingPage + 1).fill().map(function (v, i) {
    var index = startingPage + i;
    return _react2.default.createElement(
      'button',
      {
        disabled: disabled || index === currentPage && disableCurrent,
        key: index,
        className: (0, _classnames2.default)('bc-pagination__page', {
          'bc-pagination__page--selected': index === currentPage
        }),
        onClick: function onClick() {
          return onChange(index);
        }
      },
      index + 1
    );
  });

  var onChangePage = function onChangePage(page) {
    return function () {
      onChange(page);
    };
  };

  return _react2.default.createElement(
    'div',
    { className: 'bc-pagination' },
    lastPage >= 1 + 2 * offset && _react2.default.createElement(
      'button',
      {
        disabled: disabled,
        className: 'bc-pagination__next',
        onClick: onChangePage(0)
      },
      _react2.default.createElement(Back, { color: '#9B9B9B' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'bc-pagination__page-group' },
      listPages
    ),
    lastPage >= 1 + 2 * offset && _react2.default.createElement(
      'button',
      {
        disabled: disabled,
        className: 'bc-pagination__next bc-pagination__next-forward',
        onClick: onChangePage(lastPage)
      },
      _react2.default.createElement(Back, { color: '#9B9B9B' })
    )
  );
});

var Back = (0, _react.memo)(function (_ref2) {
  var color = _ref2.color;
  return _react2.default.createElement(
    'svg',
    { viewBox: '0 0 512 512' },
    _react2.default.createElement('path', { fill: color ? '' + color : "#aeb5bd", d: 'M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z' })
  );
});

Pager.defaultProps = {
  offset: 2,
  itemsPerPage: 10,
  disabled: false,
  maxPages: null,
  disableCurrent: true
};
Pager.propTypes = {
  currentPage: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  totalItems: _propTypes2.default.number,
  itemsPerPage: _propTypes2.default.number,
  offset: _propTypes2.default.number,
  disabled: _propTypes2.default.bool,
  maxPages: _propTypes2.default.number,
  disableCurrent: _propTypes2.default.bool
};

exports.default = Pager;